import { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";

interface PageErrorTemplateProps {
    errorCode: number;
    errorMessage: string;
}

const PageErrorTemplate: FC<PageErrorTemplateProps> = ({ errorCode, errorMessage }) => {

    return (
        <div className="min-h-screen w-full flex flex-col justify-center items-center bg-gray-50">
            <h1 className="text-6xl font-bold text-primary-6000 mb-2">{errorCode}</h1>
            <p className="text-lg text-gray-700">{errorMessage}</p>
            <div>
                <ButtonPrimary href="/" className="mt-4">
                    Go to Home
                </ButtonPrimary>
            </div>
        </div>
    );
};

export default PageErrorTemplate;